import {
  BatchCollectionMgmtListByCollectionConditionListItem,
  BatchCollectionMgmtListByCollectionConditionListItemFromJSON
} from '@/api/models/batch/BatchCollectionMgmtListByCollectionConditionListItem'

export interface BatchCollectionMgmtListByCollectionPageLoadResult {
  items: BatchCollectionMgmtListByCollectionConditionListItem
}

export function BatchCollectionMgmtListByCollectionPageLoadResultFromJSON(
  json: any
): BatchCollectionMgmtListByCollectionPageLoadResult {
  return {
    items: BatchCollectionMgmtListByCollectionConditionListItemFromJSON(json)
  }
}
